import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import failuresMapReducer from '../views/FailuresMap/reducers/FailuresMapReducer';
import voiceReducer from '../views/Tracker/reducers/VoiceReducer';
import packetReducer from '../views/Tracker/reducers/PacketReducer';
import mapReducer from '../components/Map/reducers/MapReducer';
import algorithmsReducer from '../views/Algorithms/reducers/AlgorithmsReducer';
import repositoryReducer from '../views/RepositoryPdf/reducers/RepositoryPdfReducer';
import optSiteReducer from '../views/OptimizationsSiteTracker/reducers/OptSiteReducer';
import optOverallReducer from '../views/OptimizationsOverallTracker/reducers/OptOverallReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	dashboardInspectReducer,
	voiceReducer,
	packetReducer,
	mapReducer,
	failuresMapReducer,
	algorithmsReducer,
	repositoryReducer,
	optSiteReducer,
	optOverallReducer
});

export default rootReducer;
